// src/neighborhoodNames.js
const neighborhoodNames = [
  "Columbia City",
  "Brighton",
  "Hitt's Hill",
  "Lakewood",
  "Lakewood-Seward Park",
  "Seward Park",
  "Genessee",
  "Mt. Baker",
  "Beacon Hill", 
  "South Beacon Hill",
  "Hillman City",
  "Graham Hill",
  "Rainier Valley",
  "Dunlap",
  "Rainier Vista"
];

export default neighborhoodNames;